import { useEffect, useState } from "react";
import BarChart from "../../components/PlayerLanding/PlayerSearch/BarChart";
import { PlayerFilterText, PlayerSearchResultsStyled } from "../../styled-components/PlayerComponent.styles";
import LabelText from "../../ui/LabelText";
import { ISelectedOption, useClubSearch } from "../../contexts/ClubSearchContext";
import FilteredDropdown from "../../ui/FilterDropdown/index";
import { useLoading } from "../../contexts/LoadingContext";
import IApiResponse from "../../types/IApiResponse";
import { fetchData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import handleApiResponse from "../../utils/handleApiResponse";
import PrimaryButton from "../../ui/PrimaryButton";
import { IClubFilterOptions, IClubSearchFilterOptions } from "../../types/IClubSearch";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../ui/LoadingSpinner";
import { Label } from "@mui/icons-material";
import RadioButton from "../../ui/CustomRadioButton";
import { RadioGroup } from "@mui/material";
import InfoIcon from "../../assets/icons/infoicon.svg"
import Info_Icon from "../../assets/icons/info-icon.svg"
const valuelabel = [
  { key: "1", value: "PER WEEK" },
  { key: "2", value: "ANNUAL" },
];
const squadPurchaseCost = [
  { key: "1", value: "WHOLE SQUAD" },
  { key: "2", value: "REGULAR STARTERS" },
];
const revenuelabel = [
  { key: "1", value: "PER WEEK" },
  { key: "2", value: "ANNUAL" },
];
const valueSliderData = [
  { value: 26, number: 5 },
  { value: 27, number: 20 },
  { value: 28, number: 10 },
  { value: 29, number: 25 },
  { value: 30, number: 30 },
  { value: 31, number: 35 },
  { value: 32, number: 50 },
  { value: 33, number: 70 },
  { value: 34, number: 40 },
  { value: 35, number: 60 },
  { value: 36, number: 30 },
  { value: 37, number: 25 },
];
const wagesSliderData = [
  { wages: 26, number: 5 },
  { wages: 27, number: 20 },
  { wages: 28, number: 10 },
  { wages: 29, number: 25 },
  { wages: 30, number: 30 },
  { wages: 31, number: 35 },
  { wages: 32, number: 50 },
  { wages: 33, number: 70 },
  { wages: 34, number: 40 },
  { wages: 35, number: 60 },
  { wages: 36, number: 30 },
  { wages: 37, number: 25 },
];

type EfficiencyOption = "any" | "earlyMover" | "average" | "lateMover";
type LeaguePosition = "anyLeague" | "top3" | "top6" | "topHalf" | "midTable" | "bottomHalf" | "relegationZone";

const transferWindowOptions: Record<EfficiencyOption, string> = {
  any: "Any",
  earlyMover: "Early Mover",
  average: "Average",
  lateMover: "Late Mover",
};

const leaguePositionOptions: Record<LeaguePosition, string> = {
  anyLeague: "Any",
  top3: "Top 3",
  top6: "Top 6",
  topHalf: "Top half",
  midTable: "Mid table",
  bottomHalf: "Bottom half",
  relegationZone: "Relegation zone"
}

export interface IMinMaxData {
  minTotalRevenue: number;
  maxTotalRevenue: number;
  minTotalCost: number;
  maxTotalCost: number;
  minTotalProfitLoss: number;
  maxTotalProfitLoss: number;
  minTotalDebt: number;
  maxTotalDebt: number;
  minAssetsLiabilities: number;
  maxAssetsLiabilities: number;
  minDebtVsAssetsRatio: number;
  maxDebtVsAssetsRatio: number;
  minTotalIntangibleAssets: number;
  maxTotalIntangibleAssets: number;
  minTotalReceivables: number;
  maxTotalReceivables: number;
  minReceivablesPercentage: number;
  maxReceivablesPercentage: number;
  minAvSquadValue: number,
  maxAvSquadValue: number,
  minAvSystemFit: number,
  maxAvSystemFit: number,
  minAvPlayerAge: number,
  maxAvPlayerAge: number,
  minPurchaseVsMarketValue: number,
  maxPurchaseVsMarketValue: number,
  isPurchaseVsMarketValueWhole: boolean,
}


const ClubSearchInit = () => {
  const {
    regionAreaData,
    setRegionAreaData,
    clubfilterValues,
    setClubFilterValues,
    setIsClubFilterChange,
    clubRegionValues,
    setClubRegionValues,
    setIsRevenueAnnual,
    setIsWageAnnual,
    WagesPA,
    setWagesPA,
    WagesPW,
    setWagesPW,
    selectedclubWagesLabel,
    setSelectedClubWagesLabel,
    selectedclubRevenueLabel,
    setSelectedclubRevenueLabel,
    isFilterChange,
    setIsFilterChange,
    totalRevenue,
    setTotalRevenue,
    totalCost,
    setTotalCost,
    totalProfitLoss,
    setTotalProfitLoss,
    totalDebt,
    setTotalDebt,
    retainedEraning,
    setRetainedEraning,
    debtVsAssetsRatio,
    setDebtVsAssetsRatio,
    totalIntangibleAssets,
    setTotalIntangibleAssets,
    totalReceivables,
    setTotalReceivables,
    receivablesPercentage,
    setReceivablesPercentage,
    avgSquadValue,
    setAvgSquadValue,
    squadPurchaseCostVSValue,
    setSquadPurchaseCostVSValue,
    avgSystemFit,
    setAvgSystemFit,
    avgPlayerAge,
    setAvgPlayerAge,
    minMaxData,
    setMinMaxData,
    setInculdeFinancial,
    includeFinancial,
    wholeSquad,
    setWholeSquad
  } = useClubSearch();
  const { loading, startLoading, stopLoading } = useLoading();
  // const [minMaxData , setMinMaxData] = useState<IMinMaxData | undefined>();
  const [selectedLabel, setSelectedLabel] = useState<string>(selectedclubWagesLabel);
  const [selectedRevenueLabel, setSelectedRevenueLabel] = useState<string>(selectedclubRevenueLabel);
  const [region, setRegion] = useState<ISelectedOption[]>(clubRegionValues);
  const [selectedEfficiencyOption, setSelectedEfficiencyOption] = useState<EfficiencyOption>("any");
  const [selectedLeaguePosition, setSelectedLeaguePosition] = useState<LeaguePosition>("anyLeague");
 // Setting default values until API data is received
 const [clubTotalRevenue, setClubTotalRevenue] = useState<{ min: number; max: number }>({min: 0,max: 100000000});
  const [clubTotalCost, setClubTotalCost] = useState<{ min: number; max: number }>({min: 0,max: 50000000});
  const [clubTotalProfitLoss, setClubTotalProfitLoss] = useState<{ min: number; max: number }>({min: -5000000,max: 5000000});
  const [clubTotalDebt, setClubTotalDebt] = useState<{ min: number; max: number }>({min: 0,max: 20000000});
  const [clubRetainEarnings, setClubRetainEarnings] = useState<{ min: number; max: number }>({min: -1300000000,max: 520000000});
  const [clubDebtVsAssetsRatio, setClubDebtVsAssetsRatio] = useState<{ min: number; max: number }>({min: 0, max: 1});
  const [clubTotalIntangibleAssets, setClubTotalIntangibleAssets] = useState<{ min: number; max: number }>({min: 0,max: 10000000});
  const [clubTotalReceivables, setClubTotalReceivables] = useState<{ min: number; max: number }>({min: 0,max: 5000000});
  const [clubReceivablesPercentage, setClubReceivablesPercentage] = useState<{ min: number; max: number }>({min: 0,max: 100});
  const [clubSquadValue, setClubSquadValue] = useState<{ min: number; max: number }>({min: 0,max: 10000000});
  const [clubSquadPurchaseCost, setClubSquadPurchaseCost] = useState<{ min: number; max: number }>({min: 0,max: 180000000});
  const [clubRegularPurchaseCost, setClubRegularPurchaseCost] = useState<{ min: number; max: number }>({min: 0,max: 180000000});
  const [clubSystemFit, setClubSystemFit] = useState<{ min: number; max: number }>({min: 0,max: 10});
  const [clubWholeSquad, setClubWholeSquad] = useState<{ min: number; max: number }>({min: 0,max: 10});
  const [clubPlayerAge, setClubPlayerAge] = useState<{ min: number; max: number }>({min: 16,max: 40});

  const [includeFinancialParameters , setInculdeFinancialParameters] = useState<boolean>(false)

// Update state when `minMaxData` changes
useEffect(() => {
  if (minMaxData) {
    setClubTotalRevenue({
      min: minMaxData.minTotalRevenue ?? 0,
      max: minMaxData.maxTotalRevenue ?? 100000000,
    });

    setClubTotalCost({
      min: minMaxData.minTotalCost ?? 0,
      max: minMaxData.maxTotalCost ?? 50000000,
    });

    setClubTotalProfitLoss({
      min: minMaxData.minTotalProfitLoss ?? -5000000,
      max: minMaxData.maxTotalProfitLoss ?? 5000000,
    });

    setClubTotalDebt({
      min: minMaxData.minTotalDebt ?? 0,
      max: minMaxData.maxTotalDebt ?? 20000000,
    });

    setClubRetainEarnings({
      min: minMaxData.minRetainedEarnings ?? -1300000000,
      max: minMaxData.maxRetainedEarnings ?? 520000000,
    });

    setClubDebtVsAssetsRatio({
      min: minMaxData.minDebtVsAssetsRatio ?? 0,
      max: minMaxData.maxDebtVsAssetsRatio ?? 1,
    });

    setClubTotalIntangibleAssets({
      min: minMaxData.minTotalIntangibleAssets ?? 0,
      max: minMaxData.maxTotalIntangibleAssets ?? 10000000,
    });

    setClubTotalReceivables({
      min: minMaxData.minTotalReceivables ?? 0,
      max: minMaxData.maxTotalReceivables ?? 5000000,
    });

    setClubReceivablesPercentage({
      min: minMaxData.minReceivablesPercentage ?? 0,
      max: minMaxData.maxReceivablesPercentage ?? 100,
    });

    setClubSquadValue({
      min: minMaxData.minAvSquadValue ?? 0,
      max: minMaxData.maxAvSquadValue ?? 10000000,
    });

    setClubSquadPurchaseCost({
      min: minMaxData.minPurchaseVsMarketValue ?? 0,
      max: minMaxData.maxPurchaseVsMarketValue ?? 180000000,
    });

    setClubWholeSquad({
      min: minMaxData.minPurchaseVsMarketValue ?? 0,
      max: minMaxData.maxPurchaseVsMarketValue ?? 10,
    });


    setClubSystemFit({
      min: minMaxData.minAvSystemFit ?? 0,
      max: minMaxData.maxAvSystemFit ?? 10,
    });

    setClubPlayerAge({
      min: minMaxData.minAvPlayerAge ?? 16,
      max: minMaxData.maxAvPlayerAge ?? 40,
    });
  }
}, [minMaxData]); // Runs when `minMaxData` updates


  const navigate = useNavigate();

  // useEffect(() => {
  //   setClubTotalRevenue({ min: minMaxData?.minTotalRevenue!, max: minMaxData?.maxTotalRevenue! })
  //   setClubTotalCost({ min: minMaxData?.minTotalCost!, max: minMaxData?.maxTotalCost! })
  //   setClubTotalProfitLoss({ min: minMaxData?.minTotalProfitLoss!, max: minMaxData?.maxTotalProfitLoss! })
  //   setClubTotalDebt({ min: minMaxData?.minTotalDebt!, max: minMaxData?.maxTotalDebt! })
  //   setClubAssetsLiabilities({ min: minMaxData?.minAssetsLiabilities!, max: minMaxData?.maxAssetsLiabilities! })
  //   setClubDebtVsAssetsRatio({ min: minMaxData?.minDebtVsAssetsRatio!, max: minMaxData?.maxDebtVsAssetsRatio! })
  //   setClubTotalIntangibleAssets({ min: minMaxData?.minTotalIntangibleAssets!, max: minMaxData?.maxTotalIntangibleAssets! })
  //   setClubTotalReceivables({ min: minMaxData?.minTotalReceivables!, max: minMaxData?.maxTotalReceivables! })
  //   setClubReceivablesPercentage({ min: minMaxData?.minReceivablesPercentage!, max: minMaxData?.maxReceivablesPercentage! })
  //   setClubSquadValue({ min: minMaxData?.minAvSquadValue!, max: minMaxData?.maxAvSquadValue! })
  //   setClubSystemFit({ min: minMaxData?.minAvSystemFit!, max: minMaxData?.maxAvSystemFit! })
  //   setClubPlayerAge({ min: minMaxData?.minAvPlayerAge!, max: minMaxData?.maxAvPlayerAge! })
  //   setClubSquadPurchaseCost({ min: minMaxData?.minPurchaseVsMarketValue!, max: minMaxData?.maxPurchaseVsMarketValue! })
  // }, [minMaxData])

  const handleWagesValueSliderChange = (min: number, max: number) => {
    if (selectedLabel === "1") {
      setWagesPW((prevRange) => ({
        min: min !== undefined ? min : prevRange.min,
        max: max !== undefined ? max : prevRange.max,
      }));
    } else {
      setWagesPA((prevRange) => ({
        min: min !== undefined ? min : prevRange.min,
        max: max !== undefined ? max : prevRange.max,
      }));
    }
    setIsFilterChange(true);
  };
  const handleRevenueValueSliderChange = (min: number, max: number) => {
    setTotalRevenue({ min: min, max: max });
    setClubTotalRevenue({ min: min, max: max });
  };
  const handleCostValueSliderChange = (min: number, max: number) => {
    setTotalCost({ min: min, max: max });
    setClubTotalCost({ min: min, max: max });
  }
  const handleProfitLossValueSliderChange = (min: number, max: number) => {
    setTotalProfitLoss({ min: min, max: max });
    setClubTotalProfitLoss({ min: min, max: max });
  }
  const handleDebtValueSliderChange = (min: number, max: number) => {
    setTotalDebt({ min: min, max: max });
    setClubTotalDebt({ min: min, max: max });
  }
  const handleRetainEarnings = (min: number, max: number) => {
    setRetainedEraning({ min: min, max: max });
    setClubRetainEarnings({ min: min, max: max });
  }
  const handleDebtVSAssestRatioSliderChange = (min: number, max: number) => {
    setDebtVsAssetsRatio({ min: min, max: max });
    setClubDebtVsAssetsRatio({ min: min, max: max });
  }
  const handleIntangibleAssetsSliderChange = (min: number, max: number) => {
    setTotalIntangibleAssets({ min: min, max: max });
    setClubTotalIntangibleAssets({ min: min, max: max });
  }
  const handleReceivablesSliderChange = (min: number, max: number) => {
    setTotalReceivables({ min: min, max: max });
    setClubTotalReceivables({ min: min, max: max });
  }
  const handleEstimateReceivablesSliderChange = (min: number, max: number) => {
    setReceivablesPercentage({ min: min, max: max });
    setClubReceivablesPercentage({ min: min, max: max });
  }
  const handleSquadValueSliderChange = (min: number, max: number) => {
    setAvgSquadValue({ min: min, max: max });
    setClubSquadValue({ min: min, max: max });
  }
  const handleSquadPurchaseCostVSCurrentValueSliderChange = (min: number, max: number) => {
    // setSquadPurchaseCostVSValue({ min: min, max: max });
    // setClubSquadPurchaseCost({ min: min, max: max });
    if (selectedLabel === "1") {
      setSquadPurchaseCostVSValue({ min: min, max: max });
      setClubSquadPurchaseCost({ min: min, max: max });
    } else {
      setClubRegularPurchaseCost((prevRange) => ({
        min: min !== undefined ? min : prevRange.min,
        max: max !== undefined ? max : prevRange.max,
      }));
    }
    setIsFilterChange(true);
  }

  const handleOnWagesToggleChange = (SelectedTab: any) => {
    setSelectedLabel(SelectedTab.key);
    setSelectedClubWagesLabel(SelectedTab.key);
    setIsWageAnnual(true);
    setIsFilterChange(true);
  };
  // const handleOnRevenueToggleChange = (SelectedTab: any) => {
  //   setSelectedRevenueLabel(SelectedTab.key);
  //   setSelectedclubRevenueLabel(SelectedTab.key);
  //   setIsRevenueAnnual(true);
  //   setIsFilterChange(true);
  // };
  const handleSelectionRegionChange = async (selectedOptions: ISelectedOption[]) => {
    startLoading();
    setRegion((prevRegion) => {
      if (selectedOptions.length > 0) {
        const rolesByRegion: Record<string, ISelectedOption[]> = {};
        prevRegion.forEach((area) => {
          if (!rolesByRegion[area.region]) {
            rolesByRegion[area.region] = [];
          }
          rolesByRegion[area.region].push(area);
        });
        selectedOptions.forEach((newOption) => {
          const existingOptions = rolesByRegion[newOption.region];
          if (existingOptions) {
            existingOptions.forEach((existingOption) => {
              const index = prevRegion.findIndex((area) => area.optionId === existingOption.optionId);
              if (index !== -1) {
                prevRegion.splice(index, 1);
              }
            });
          }
        });
        const updatedRoles = [...prevRegion, ...selectedOptions];
        setClubRegionValues(updatedRoles);
        return updatedRoles;
      } else {
        return [];
      }
    });
    await new Promise((resolve) => setTimeout(resolve, 500));
    stopLoading();
  };
  const handleClubSearchResult = () => {
    //navigate(`/clubs`);

    const newFilterValues: IClubSearchFilterOptions = {
      areaId: region.map((option) => option.optionId),
      competitionId: [],
      minTotalRevenue: clubTotalRevenue.min,
      maxTotalRevenue: clubTotalRevenue.max,
      minTotalCost: clubTotalCost.min,
      maxTotalCost: clubTotalCost.max,
      minTotalProfitLoss: clubTotalProfitLoss.min,
      maxTotalProfitLoss: clubTotalProfitLoss.max,
      minTotalDebt: clubTotalDebt.min,
      maxTotalDebt: clubTotalDebt.max,
      minAssetsLiabilities: clubRetainEarnings.min,
      maxAssetsLiabilities: clubRetainEarnings.max,
      minDebtVsAssetsRatio: clubDebtVsAssetsRatio.min,
      maxDebtVsAssetsRatio: clubDebtVsAssetsRatio.max,
      minTotalIntangibleAssets: clubTotalIntangibleAssets.min,
      maxTotalIntangibleAssets: clubTotalIntangibleAssets.max,
      minTotalReceivables: clubTotalReceivables.min,
      maxTotalReceivables: clubTotalReceivables.max,
      orderName: 'revenue',
      ordering: 'asc'
    };
    setIsClubFilterChange(true);
    //setClubFilterValues(newFilterValues);
    setIsFilterChange(false);
    navigate("/clubsearchresult");
  };

  useEffect(() => {
    const fetchAllAreaByRegions = async () => {
      const response: IApiResponse<any> = await fetchData(`${apiUrls["GetAllAreaByRegions"]}`);
      handleApiResponse(
        response,
        (regionareaData) => {
          setRegionAreaData(regionareaData);
        },
        (error) => {
          console.error("Error fetching Home Team Data:", error);
        }
      );
    };
    if (regionAreaData === undefined) fetchAllAreaByRegions();
  }, []);

  useEffect(() => {
    const fetchMinMaxData = async () => {
      startLoading();
      const response: IApiResponse<IMinMaxData> = await fetchData(`${apiUrls["GetMinMaxValuesForTeamFilterSearch"]}`);
      handleApiResponse(
        response,
        (minmaxData) => {
          setMinMaxData(minmaxData);
          stopLoading()
        },
        (error) => {
          console.error("Error fetching Home Team Data:", error);
          stopLoading()
        }
      );
    }
    fetchMinMaxData();
  }, [])

  const handleSelectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedEfficiencyOption(event.target.value as EfficiencyOption);
  };
  const handleLeaguePositionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLeaguePosition(event.target.value as LeaguePosition);
  };

  const handlePlayerAgeSliderChange = (min: number, max: number) => {
    setClubPlayerAge({ min: min, max: max });
    setAvgPlayerAge({ min: min, max: max });

  }
  const handleSystemFitSliderChange = (min: number, max: number) => {
    setClubSystemFit({ min: min, max: max });
    setAvgSystemFit({ min: min, max: max });
  }

  const handleClubWholeSquad = (min: number, max: number) => {
    setClubWholeSquad({ min: min, max: max });
    setWholeSquad({ min: min, max: max });
  }

  return (
    <div className="club-init-top-container">
      <PlayerFilterText className="player-filter-text">
        <LabelText className="drawer-title">Create a club list</LabelText>
      </PlayerFilterText>
      <div className="club-filters-content">
        
        <div className="club-filters-right">
          <LabelText className="player-search-text">Squad</LabelText>
          <BarChart
            header="Av. Player value"
            data={valueSliderData}
            onDataUpdate={handleSquadValueSliderChange}
            initialMinValue={minMaxData?.minAvSquadValue!}
            initialMaxValue={minMaxData?.maxAvSquadValue!}
            defaultSelectedValue={[clubSquadValue.min, clubSquadValue.max]}
            isFor={"Transfer Value"}
          />
          {/* <BarChart
            header="squad purchase cost / current value"
            togglelabel={squadPurchaseCost}
            data={valueSliderData}
            onDataUpdate={handleSquadPurchaseCostVSCurrentValueSliderChange}
            initialMinValue={selectedLabel === "1" ? minMaxData?.minPurchaseVsMarketValue! : 0}
            //minMaxData?.isPurchaseVsMarketValueWhole! ? minMaxData?.minPurchaseVsMarketValue! : 0}
            initialMaxValue={selectedLabel === "1" ? minMaxData?.maxPurchaseVsMarketValue! : 180000000}
            // minMaxData?.isPurchaseVsMarketValueWhole! ? minMaxData?.maxPurchaseVsMarketValue! : 180000000}
            defaultSelectedValue={selectedLabel === "1" ? [clubSquadPurchaseCost.min, clubSquadPurchaseCost.max] : [clubRegularPurchaseCost.min, clubRegularPurchaseCost.max]}
            isFor={selectedLabel === "1" ? "" : "Transfer Value"}
            onChange={handleOnWagesToggleChange}
            selectedLabel={selectedLabel}
          /> */}
          <BarChart
            header="Purchase Cost / Current Value"
            data={valueSliderData}
            onDataUpdate={handleClubWholeSquad}
            initialMinValue={minMaxData?.minPurchaseVsMarketValue!}
            initialMaxValue={minMaxData?.maxPurchaseVsMarketValue!}
            defaultSelectedValue={[clubWholeSquad.min, clubWholeSquad.max]}
          />
          <BarChart
            header="Av. System fit"
            data={valueSliderData}
            onDataUpdate={handleSystemFitSliderChange}
            initialMinValue={minMaxData?.minAvSystemFit!}
            initialMaxValue={minMaxData?.maxAvSystemFit!}
            defaultSelectedValue={[clubSystemFit.min, clubSystemFit.max]}
          />
          <div className="outstanding-receivables-wrapper">
            <BarChart
              header="Av. player age"
              data={valueSliderData}
              onDataUpdate={handlePlayerAgeSliderChange}
              initialMinValue={minMaxData?.minAvPlayerAge!}
              initialMaxValue={minMaxData?.maxAvPlayerAge!}
              defaultSelectedValue={[clubPlayerAge.min, clubPlayerAge.max]}
            />
          </div>
          {/* <div className="efficiency-options-container league-position">
            <LabelText className="player-search-text">League position</LabelText>
            {Object.entries(leaguePositionOptions).map(([key, label]) => (
              <div className="efficiency-options-wrapper">
                <RadioButton
                  key={key}
                  label={label}
                  name={key}
                  value={key}
                  checked={selectedLeaguePosition === key}
                  onChange={handleLeaguePositionChange}
                />
              </div>
            ))}
          </div> */}
          <div className="efficiency-options-container">
            <LabelText className="player-search-text">Club league</LabelText>
            {regionAreaData?.map((regionItem) => (
              <FilteredDropdown
                key={regionItem.region}
                region={regionItem.region}
                options={regionItem.areas}
                type={regionItem.region}
                onChange={handleSelectionRegionChange}
                includeAll={true}
                displayAsDropdown={true}
              />
            ))}
          </div>
        </div>
        <div className="club-filters-left">
          <LabelText className="player-search-text">Financial</LabelText>

          <div className="financial-search">
              <div className="financial-search-label" style={{cursor:'pointer',backgroundColor : includeFinancial ? '#FFF' : '#00D1A8',border : includeFinancial ? '1px solid #DADADA' : '1px solid #00BE99'}} 
              onClick={() =>{setInculdeFinancial(!includeFinancial)}}>
                  <LabelText className="secondary-cta-text">{includeFinancial ? 'Remove financial parameters' : 'Include financial parameters'}</LabelText>
              </div>
              <div className="financial-search-container">
                  <div className="financial-search-content">
                      <div style={{marginTop:'6px'}}><img src={Info_Icon}/></div>
                      <div>
                        <LabelText className="market-value-text">Only clubs who’ve supplied the relevant financial data will surface if financial parameters are included.</LabelText>
                        <div></div>
                        <LabelText className="global-search-text">Not all countries require their football clubs to release financial data, and some countries only require a limited set of data is made public.</LabelText>
                      </div>
                  </div>
              </div>
          </div>
          {includeFinancial && (
            <>
            <BarChart
            header="Revenue"
            data={wagesSliderData}
            onDataUpdate={handleRevenueValueSliderChange}
            initialMinValue={minMaxData?.minTotalRevenue!}
            initialMaxValue={minMaxData?.maxTotalRevenue!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalRevenue.min!, clubTotalRevenue.max]}
          />
          <BarChart
            header="Costs"
            data={wagesSliderData}
            onDataUpdate={handleCostValueSliderChange}
            initialMinValue={minMaxData?.minTotalCost!}
            initialMaxValue={minMaxData?.maxTotalCost!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalCost.min, clubTotalCost.max]}
          />
          <BarChart
            header="Profit/loss"
            data={wagesSliderData}
            onDataUpdate={handleProfitLossValueSliderChange}
            initialMinValue={minMaxData?.minTotalProfitLoss!}
            initialMaxValue={minMaxData?.maxTotalProfitLoss!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalProfitLoss.min, clubTotalProfitLoss.max]}
          />
          <BarChart
            header="Debt"
            data={wagesSliderData}
            onDataUpdate={handleDebtValueSliderChange}
            initialMinValue={minMaxData?.minTotalDebt!}
            initialMaxValue={minMaxData?.maxTotalDebt!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalDebt.min, clubTotalDebt.max]}
          />
          <BarChart
            // header="Assets/liabilities"
            header="Retained Earnings"
            data={wagesSliderData}
            onDataUpdate={handleRetainEarnings}
            initialMinValue={minMaxData?.minRetainedEarnings!}
            initialMaxValue={minMaxData?.maxRetainedEarnings!}
            defaultSelectedValue={[clubRetainEarnings.min, clubRetainEarnings.max]}
            isFor={"Transfer Value"}
          />
          <BarChart
            header="Debt VS asset ratio"
            data={wagesSliderData}
            onDataUpdate={handleDebtVSAssestRatioSliderChange}
            initialMinValue={minMaxData?.minDebtVsAssetsRatio!}
            initialMaxValue={minMaxData?.maxDebtVsAssetsRatio!}
            defaultSelectedValue={[clubDebtVsAssetsRatio.min, clubDebtVsAssetsRatio.max]}
          />
          <BarChart
            header="Intangible assets"
            data={wagesSliderData}
            onDataUpdate={handleIntangibleAssetsSliderChange}
            initialMinValue={minMaxData?.minTotalIntangibleAssets!}
            initialMaxValue={minMaxData?.maxTotalIntangibleAssets!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalIntangibleAssets.min, clubTotalIntangibleAssets.max]}
          />

          <BarChart
            header="Outstanding receivables"
            data={wagesSliderData}
            onDataUpdate={handleReceivablesSliderChange}
            initialMinValue={minMaxData?.minTotalReceivables!}
            initialMaxValue={minMaxData?.maxTotalReceivables!}
            isFor={"Transfer Value"}
            defaultSelectedValue={[clubTotalReceivables.min, clubTotalReceivables.max]}
          />

          <div className="outstanding-receivables-wrapper">
            <BarChart
              header="Players Receivables % of Total Revenue"
              data={wagesSliderData}
              onDataUpdate={handleEstimateReceivablesSliderChange}
              initialMinValue={minMaxData?.minReceivablesPercentage!}
              initialMaxValue={minMaxData?.maxReceivablesPercentage!}
              defaultSelectedValue={[clubReceivablesPercentage.min, clubReceivablesPercentage.max]}
            />
          </div>
          {/* <div className="efficiency-options-container">
            <LabelText className="player-search-text">Transfer window efficiency</LabelText>
            {Object.entries(transferWindowOptions).map(([key, label]) => (
              <div className="efficiency-options-wrapper">
                <RadioButton
                  key={key}
                  label={label}
                  name={key}
                  value={key}
                  checked={selectedEfficiencyOption === key}
                  onChange={handleSelectionChange}
                />
              </div>
            ))}
          </div> */}

            </>
          )}
      </div>
      </div>
      {/* <div className="club-filters-content">
        <div className="club-filter-left">
          <BarChart
            header="Av. WAGe"
            togglelabel={valuelabel}
            data={valueSliderData}
            onDataUpdate={handleWagesValueSliderChange}
            initialMinValue={0}
            initialMaxValue={180000000}
            defaultSelectedValue={selectedLabel === "1" ? [WagesPW.min, WagesPW.max] : [WagesPA.min, WagesPA.max]}
            isFor={"Transfer Value"}
            onChange={handleOnWagesToggleChange}
            selectedLabel={selectedLabel}
          />
        </div>
        <div className="club-filter-right">
          <BarChart
            header="Revenue"
            togglelabel={revenuelabel}
            data={wagesSliderData}
            onDataUpdate={handleRevenueValueSliderChange}
            initialMinValue={0}
            initialMaxValue={180000000}
            isFor={"Transfer Value"}
            defaultSelectedValue={selectedRevenueLabel === "1" ? [clubrevenuePW.min, clubrevenuePW.max] : [clubrevenuePA.min, clubrevenuePA.max]}
            onChange={handleOnRevenueToggleChange}
            selectedLabel={selectedRevenueLabel}
          />
        </div>
      </div>
      <div className="club-filter-region">
        <LabelText className="player-search-text">Region</LabelText>
        {regionAreaData?.map((regionItem) => (
          <FilteredDropdown
            key={regionItem.region}
            region={regionItem.region}
            options={regionItem.areas}
            type={regionItem.region}
            onChange={handleSelectionRegionChange}
            includeAll={true}
            displayAsDropdown={true}
          />
        ))}
      </div> */}
      <PlayerSearchResultsStyled className="player-search-profile-result">
        <div className="search-results-content">
          <PrimaryButton label="Create list" onClick={handleClubSearchResult} />
        </div>
      </PlayerSearchResultsStyled>
      {loading && <LoadingSpinner />}
    </div>
  );
};

export default ClubSearchInit;
